module.exports = __webpack_public_path__ + "static/img/taide-art-black.93904ca.png";